module.exports = __webpack_public_path__ + "img/v1.18f943f7.png";